import React from "react";
import "antd/dist/antd.less";
import { Layout } from "antd";
import DncpHeader from "./components/DncpHeader";
import AwardedProvidersContent from "./components/AwardedProvidersContent";
import BiddingProvidersContent from "./components/BiddingProvidersContent";
import "./App.css";

const { Header } = Layout;

const url = process.env.REACT_APP_API_URL;

export default function App() {
  const [activeTab, setActiveTab] = React.useState("entidades_proveedores");

  function onTabChange(key) {
    setActiveTab(key);
  }

  return (
    <Layout className="App">
      <Header>
        <DncpHeader onTabChange={onTabChange}></DncpHeader>
      </Header>
      {activeTab === "entidades_proveedores" && (
        <AwardedProvidersContent url={url}></AwardedProvidersContent>
      )}
      {activeTab === "proveedores" && (
        <BiddingProvidersContent url={url}></BiddingProvidersContent>
      )}
    </Layout>
  );
}
